export default __webpack_public_path__ + "static/media/pass.3c37d4c7.png";